/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsDesignElement,
    SharedserviceMelcoModelsDesignElementFromJSON,
    SharedserviceMelcoModelsDesignElementFromJSONTyped,
    SharedserviceMelcoModelsDesignElementToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesignMetadata
 */
export interface SharedserviceMelcoModelsDesignMetadata {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    stitches?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    colors?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    trims?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    color_changes?: number;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignElement>}
     * @memberof SharedserviceMelcoModelsDesignMetadata
     */
    elements?: Array<SharedserviceMelcoModelsDesignElement> | null;
}

export function SharedserviceMelcoModelsDesignMetadataFromJSON(json: any): SharedserviceMelcoModelsDesignMetadata {
    return SharedserviceMelcoModelsDesignMetadataFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesignMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'stitches': !exists(json, 'stitches') ? undefined : json['stitches'],
        'colors': !exists(json, 'colors') ? undefined : json['colors'],
        'trims': !exists(json, 'trims') ? undefined : json['trims'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'color_changes': !exists(json, 'color_changes') ? undefined : json['color_changes'],
        'elements': !exists(json, 'elements') ? undefined : (json['elements'] === null ? null : (json['elements'] as Array<any>).map(SharedserviceMelcoModelsDesignElementFromJSON)),
    };
}

export function SharedserviceMelcoModelsDesignMetadataToJSON(value?: SharedserviceMelcoModelsDesignMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'stitches': value.stitches,
        'colors': value.colors,
        'trims': value.trims,
        'height': value.height,
        'width': value.width,
        'color_changes': value.color_changes,
        'elements': value.elements === undefined ? undefined : (value.elements === null ? null : (value.elements as Array<any>).map(SharedserviceMelcoModelsDesignElementToJSON)),
    };
}


